import { all, takeEvery } from 'redux-saga/effects';
import { appInitialize, APP_INITIALIZE } from '../middleware/initialize';
import { fetch, FETCH } from '../middleware/fetch';
import {
  CHECK_PASSWORD_PREVIOUSLY_SET,
  getPasswordPreviouslySet,
  SET_NEW_PASSWORD,
  postNewPassword,
} from '../../Onboarding/Setup/staff-password/setup-staff-password.duck';

import {
  SEND_STAFF_LIST,
  uploadCSV,
  SEND_VALIDATED_STAFF_LIST,
  uploadValidatedStaffList,
  postStaffEmail,
  SEND_STAFF_EMAIL,
} from '../../Onboarding/Setup/staff/setup-staff.duck';
import {
  SAVE_ORGANIZATION_SETTINGS,
  postToSaveOrganizationSettings,
} from '../../Onboarding/Setup/organization/setup-organization.duck';

import {
  AUTH_SUCCESS,
  INITIATE_LOGIN,
  INITIATE_LOGOUT,
  REDIRECT_TO_LOGIN,
  onAuthSuccess,
  redirectToLogin,
  logout,
} from '../auth/auth';

import {
  postWebmasterEmail,
  SEND_WEBMASTER_EMAIL,
  SET_WEBMASTER_EMAIL,
  validateEmail,
  SEND_VERIFIED_SCHOOLS,
  postVerifiedSchools,
} from '../../Onboarding/Setup/school/setup-school.duck';

import {
  SET_PARENT_UPLOADING_FILE,
  processParentCSV,
} from '../../Onboarding/Setup/parent/setup-parent.duck';

export default function* rootSaga() {
  yield all([
    takeEvery(APP_INITIALIZE, appInitialize),
    takeEvery(AUTH_SUCCESS, onAuthSuccess),
    takeEvery(REDIRECT_TO_LOGIN, redirectToLogin),
    takeEvery(INITIATE_LOGIN, redirectToLogin),
    takeEvery(INITIATE_LOGOUT, logout),
    takeEvery(FETCH, fetch),
    takeEvery(SEND_WEBMASTER_EMAIL, postWebmasterEmail),
    takeEvery(SET_WEBMASTER_EMAIL, validateEmail),
    takeEvery(SEND_VERIFIED_SCHOOLS, postVerifiedSchools),
    takeEvery(CHECK_PASSWORD_PREVIOUSLY_SET, getPasswordPreviouslySet),
    takeEvery(SET_NEW_PASSWORD, postNewPassword),
    takeEvery(SEND_STAFF_LIST, uploadCSV),
    takeEvery(SEND_VALIDATED_STAFF_LIST, uploadValidatedStaffList),
    takeEvery(SEND_STAFF_EMAIL, postStaffEmail),
    takeEvery(SAVE_ORGANIZATION_SETTINGS, postToSaveOrganizationSettings),
    takeEvery(SET_PARENT_UPLOADING_FILE, processParentCSV),
  ]);
}



// WEBPACK FOOTER //
// ./src/_app/sagas/rootSaga.js